/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { UIPrefsStore } from '@/store';
import { ifOrEmpty } from '@/utils';
export default tsx.componentFactoryOf().create({
    name: 'tenant-list-item',
    functional: true,
    props: {
        tenant: p.ofObject().required,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(_, ctx) {
        const { tenant } = ctx.props;
        const slotContent = ctx.scopedSlots.extra?.({ tenant });
        const imageWidth = '170px';
        const imageHeight = '75px';
        return (<div class={[
                'tenant-list-item d-flex flex-row align-items-center',
                ctx.data.class,
                ctx.data.staticClass,
            ]}>
                <div style={`width: ${imageWidth};`}>
                    <img src={tenant.getUrl(UIPrefsStore.darkMode())} class="d-block py-3 px-4" alt={`Logo for ${tenant.name}`} height={imageHeight} width="auto" style={{
                width: imageWidth,
                'object-fit': 'scale-down',
                margin: '0 auto',
            }}/>
                </div>
                <div class={[slotContent == null ? 'pr-2' : 'mr-4']}>
                    <b>{tenant.name}</b>
                </div>

                {ifOrEmpty(slotContent != null, () => (<div class="ml-auto mr-2">{slotContent}</div>))}
            </div>);
    },
});
